import {environment as env, environment} from '../../environments/environment';

export class UrlStore {
    public static readonly ui = {
        landing: '/',
        accessDeined: 'accessDeined',
        dashboard: 'dashboard',
        forecast: 'forecast',
        inventory: 'inventory',
        groupSales: 'group-sales',
        businessRules: 'business-rules',
        businessRulesV2: 'business-rules-v2',
        loginError: 'login/error',
        status: 'status',
        configuration: 'configuration',
        apiDocs: 'api-docs',
        portfolio: 'portfolio'
    };

    public static readonly api = {
        config: `${environment.apiBaseUrl}/config`,
        userConfiguration: `${env.apiBaseUrl}/user_configuration`,
        odGrouping: `${env.apiBaseUrl}/od_grouping`,
        tenantSettings: `${env.apiBaseUrl}/tenant_settings`,
        marketsConfig: `${env.apiBaseUrl}/markets/config`,
        businessRules: {
            base: `${env.apiBaseUrl}/business_rules`,
            bucketRules: `${env.apiBaseUrl}/business_rules/buckets`,
            bucketValidation: `${env.apiBaseUrl}/business_rules/validate/bucket`,
            daysPrior: `${env.apiBaseUrl}/business_rules/days_prior`,
            exclusionDates: `${env.apiBaseUrl}/business_rules/exclusion_dates`,
            export: `${env.apiBaseUrl}/business_rules/export`,
            journeyRules: `${env.apiBaseUrl}/business_rules/journeys`,
            parentRules: `${env.apiBaseUrl}/business_rules/parent_rules`,
            parentValidation: `${env.apiBaseUrl}/business_rules/validate/rules`,
            ruleTypes: `${env.apiBaseUrl}/business_rules/rule_types`,
            rulePriorities: `${env.apiBaseUrl}/business_rules/rule_priorities`,
            saveRulePriorities: `${env.apiBaseUrl}/business_rules/save_rule_priorities`,
            ruleDefinitions: `${env.apiBaseUrl}/business_rules/rule_definitions`,
            journeyRuleRanking: `${env.apiBaseUrl}/business_rules/journey_rule_ranking`,
            conflictReport: `${env.apiBaseUrl}/business_rules/conflict_report`,
            impactPreview: `${env.apiBaseUrl}/business_rules/impact_preview`,
            changeHistory: `${env.apiBaseUrl}/business_rules/change_history`,
            applyPreview: `${env.apiBaseUrl}/business_rules/apply_preview`,
            apply: `${env.apiBaseUrl}/business_rules/apply`
        },
        comment: `${environment.apiBaseUrl}/comment`,
        dashboard: {
            revenueChart:  `${env.apiBaseUrl}/dashboard/revenue`
        },
        forecast: {
            forecastChart: `${env.apiBaseUrl}/forecast/chart/forecast`
        },
        inventory: {
            approveRecommendation: `${env.apiBaseUrl}/inventory/approve`,
            capacityChart: `${env.apiBaseUrl}/inventory/chart/capacity`,
            defaultGridColumns: `${env.apiBaseUrl}/inventory/default_grid_columns`,
            walkUpOverride: `${env.apiBaseUrl}/inventory/override/walk_up`,
            constraintCheck: `${env.apiBaseUrl}/inventory/check_class_constraint`,
            saveBulkOverride: `${env.apiBaseUrl}/inventory/bulk_override`,
            singleOverride: `${env.apiBaseUrl}/inventory/override`,
            shoulderChart: `${env.apiBaseUrl}/inventory/chart/shoulder_train`,
            shoulderChartLegList: `${env.apiBaseUrl}/inventory/chart/shoulder_train/leg_list`,
            overrideInfo: `${env.apiBaseUrl}/inventory/override_info`,
            overrideAudit: `${env.apiBaseUrl}/inventory/override_audit`,
            heatmap: `${env.apiBaseUrl}/inventory/heatmap`,
            singleTubemap: `${env.apiBaseUrl}/inventory/chart/tube_single_train`,
            reminders: `${env.apiBaseUrl}/inventory/reminders`
        },
        groupSales: {
            grid: `${env.apiBaseUrl}/group_sales`,
            quote: `${env.apiBaseUrl}/group_sales/quote`,
            apply: `${env.apiBaseUrl}/group_sales/apply`
        },
        status: {
            grid: `${env.apiBaseUrl}/status_info`,
            lastRun: `${env.apiBaseUrl}/last_run_info`,
            rarsExceptionsSummary: `${env.apiBaseUrl}/rars_exceptions/summary`,
            rarsExceptions: `${env.apiBaseUrl}/rars_exceptions`
        },
        swapTenant: {
            swapTenantURL: `${env.apiBaseUrl}/config/swap_tenant`
        },
        public: {
            // Public API lives at /v1 on the same host (internal keeps /rail/v1)
            swaggerSpec: `${env.apiBaseUrl.replace('/rail/v1', '/v1')}/swagger.json`
        },
        // Cross-buyer (multi-TOC) combined views — RLP-4274 prototype.
        portfolio: {
            tenants: `${env.apiBaseUrl}/portfolio/tenants`,
            inventoryGrid: `${env.apiBaseUrl}/portfolio/inventory/grid`,
            dashboardMetrics: `${env.apiBaseUrl}/portfolio/dashboard/metrics`
        }
    };
}
